"use strict";

exports.__esModule = true;
exports.default = void 0;
var _setup = require("./_setup.js");
var _isDataView = _interopRequireDefault(require("./isDataView.js"));
var _constant = _interopRequireDefault(require("./constant.js"));
var _isBufferLike = _interopRequireDefault(require("./_isBufferLike.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Is a given value a typed array?
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  // `ArrayBuffer.isView` is the most future-proof, so use it when available.
  // Otherwise, fall back on the above regular expression.
  return _setup.nativeIsView ? (0, _setup.nativeIsView)(obj) && !(0, _isDataView.default)(obj) : (0, _isBufferLike.default)(obj) && typedArrayPattern.test(_setup.toString.call(obj));
}
var _default = exports.default = _setup.supportsArrayBuffer ? isTypedArray : (0, _constant.default)(false);